import request from "@/utils/request";
import dayjs from "dayjs";

// 获取待检测列表
export function getList(params) {
  return request.get("/dualCheck/list", { params });
}

// 罐口卸料列表
export function getHistoryList(params) {
  return request.get("/materialFilling/list", { params });
}

export function update(data) {
  data.startTime = dayjs(data.startTime).format("YYYY-MM-DD HH:mm:ss");
  data.endTime = dayjs(data.endTime).format("YYYY-MM-DD HH:mm:ss");
  if (data.id) return edit(data);
  return add(data);
}

// 新增罐口卸料记录
export function add(data) {
  return request.post("/materialFilling/insert", data);
}
// 编辑罐口卸料记录
export function edit(data) {
  return request.post("/materialFilling/updateById", data);
}
// 删除罐口卸料记录
export function del(data) {
  return request.get("/materialFilling/deleteById/" + data.id);
}

// 粉料检测申请
export function createOne(data) {
  return request.post("/dualCheck/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 粉料检测审核
export function updateOne(data) {
  return request.post("/dualCheck/check", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 获取消息推送列表
export function getConfigList(data) {
  return request.get("/portConfig/list");
}

// 更新消息推送信息
export function updateConfigOne(data) {
  return request.post("/portConfig/update", data);
}

// 罐料口开启
export function openOne(params) {
  return request.get("/equip/openPort", { params });
}

// 获取库存
export function getStock({ date }) {
  const params = {
    startDate: +dayjs(date[0]).startOf("day"),
    endDate: +dayjs(date[1]).endOf("day"),
  };
  return request.get("/portConfig/getStock", { params });
}
